import { dew as _buildRequestDew } from "./buildRequest.js";
import { dew as _ccipDew } from "./ccip.js";
import { dew as _assertCurrentChainDew } from "./chain/assertCurrentChain.js";
import { dew as _defineChainDew } from "./chain/defineChain.js";
import { dew as _extractChainDew } from "./chain/extractChain.js";
import { dew as _getChainContractAddressDew } from "./chain/getChainContractAddress.js";
import { dew as _regexDew } from "./regex.js";
import { dew as _rpcDew } from "./rpc.js";
import { dew as _stringifyDew } from "./stringify.js";
import { dew as _typedDataDew } from "./typedData.js";
import { dew as _decodeAbiParametersDew } from "./abi/decodeAbiParameters.js";
import { dew as _decodeErrorResultDew } from "./abi/decodeErrorResult.js";
import { dew as _decodeEventLogDew } from "./abi/decodeEventLog.js";
import { dew as _decodeFunctionDataDew } from "./abi/decodeFunctionData.js";
import { dew as _decodeFunctionResultDew } from "./abi/decodeFunctionResult.js";
import { dew as _encodeAbiParametersDew } from "./abi/encodeAbiParameters.js";
import { dew as _encodeDeployDataDew } from "./abi/encodeDeployData.js";
import { dew as _encodeErrorResultDew } from "./abi/encodeErrorResult.js";
import { dew as _encodeEventTopicsDew } from "./abi/encodeEventTopics.js";
import { dew as _encodeFunctionDataDew } from "./abi/encodeFunctionData.js";
import { dew as _encodeFunctionResultDew } from "./abi/encodeFunctionResult.js";
import { dew as _getAbiItemDew } from "./abi/getAbiItem.js";
import * as _abitype2 from "abitype";
var _abitype = _abitype2;
try {
  if ("default" in _abitype2) _abitype = _abitype2.default;
} catch (e) {}
import { dew as _encodePackedDew } from "./abi/encodePacked.js";
import { dew as _formatAbiItemWithArgsDew } from "./abi/formatAbiItemWithArgs.js";
import { dew as _formatAbiItemDew } from "./abi/formatAbiItem.js";
import { dew as _parseAccountDew } from "../accounts/utils/parseAccount.js";
import { dew as _publicKeyToAddressDew } from "../accounts/utils/publicKeyToAddress.js";
import { dew as _getContractAddressDew } from "./address/getContractAddress.js";
import { dew as _getAddressDew } from "./address/getAddress.js";
import { dew as _isAddressDew } from "./address/isAddress.js";
import { dew as _isAddressEqualDew } from "./address/isAddressEqual.js";
import { dew as _extractFunctionPartsDew } from "./contract/extractFunctionParts.js";
import { dew as _concatDew } from "./data/concat.js";
import { dew as _isBytesDew } from "./data/isBytes.js";
import { dew as _isHexDew } from "./data/isHex.js";
import { dew as _padDew } from "./data/pad.js";
import { dew as _sizeDew } from "./data/size.js";
import { dew as _sliceDew } from "./data/slice.js";
import { dew as _trimDew } from "./data/trim.js";
import { dew as _blockDew } from "./formatters/block.js";
import { dew as _transactionDew } from "./formatters/transaction.js";
import { dew as _logDew } from "./formatters/log.js";
import { dew as _transactionReceiptDew } from "./formatters/transactionReceipt.js";
import { dew as _transactionRequestDew } from "./formatters/transactionRequest.js";
import { dew as _extractDew } from "./formatters/extract.js";
import { dew as _toRlpDew } from "./encoding/toRlp.js";
import { dew as _toBytesDew } from "./encoding/toBytes.js";
import { dew as _toHexDew } from "./encoding/toHex.js";
import { dew as _fromBytesDew } from "./encoding/fromBytes.js";
import { dew as _fromHexDew } from "./encoding/fromHex.js";
import { dew as _fromRlpDew } from "./encoding/fromRlp.js";
import { dew as _getNodeErrorDew } from "./errors/getNodeError.js";
import { dew as _getCallErrorDew } from "./errors/getCallError.js";
import { dew as _getContractErrorDew } from "./errors/getContractError.js";
import { dew as _getEstimateGasErrorDew } from "./errors/getEstimateGasError.js";
import { dew as _getTransactionErrorDew } from "./errors/getTransactionError.js";
import { dew as _formatterDew } from "./formatters/formatter.js";
import { dew as _getEventSelectorDew } from "./hash/getEventSelector.js";
import { dew as _getFunctionSelectorDew } from "./hash/getFunctionSelector.js";
import { dew as _isHashDew } from "./hash/isHash.js";
import { dew as _keccakDew } from "./hash/keccak256.js";
import { dew as _hashTypedDataDew } from "./signature/hashTypedData.js";
import { dew as _recoverAddressDew } from "./signature/recoverAddress.js";
import { dew as _recoverMessageAddressDew } from "./signature/recoverMessageAddress.js";
import { dew as _recoverPublicKeyDew } from "./signature/recoverPublicKey.js";
import { dew as _recoverTypedDataAddressDew } from "./signature/recoverTypedDataAddress.js";
import { dew as _verifyMessageDew } from "./signature/verifyMessage.js";
import { dew as _verifyTypedDataDew } from "./signature/verifyTypedData.js";
import { dew as _hashMessageDew } from "./signature/hashMessage.js";
import { dew as _getSerializedTransactionTypeDew } from "./transaction/getSerializedTransactionType.js";
import { dew as _getTransactionTypeDew } from "./transaction/getTransactionType.js";
import { dew as _assertRequestDew } from "./transaction/assertRequest.js";
import { dew as _assertTransactionDew } from "./transaction/assertTransaction.js";
import { dew as _parseTransactionDew } from "./transaction/parseTransaction.js";
import { dew as _prepareTransactionRequestDew } from "../actions/wallet/prepareTransactionRequest.js";
import { dew as _serializeTransactionDew } from "./transaction/serializeTransaction.js";
import { dew as _serializeAccessListDew } from "./transaction/serializeAccessList.js";
import { dew as _formatEtherDew } from "./unit/formatEther.js";
import { dew as _formatGweiDew } from "./unit/formatGwei.js";
import { dew as _formatUnitsDew } from "./unit/formatUnits.js";
import { dew as _parseUnitsDew } from "./unit/parseUnits.js";
import { dew as _parseEtherDew } from "./unit/parseEther.js";
import { dew as _parseGweiDew } from "./unit/parseGwei.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.concat = exports.extractFunctionParts = exports.extractFunctionType = exports.extractFunctionParams = exports.extractFunctionName = exports.isAddressEqual = exports.isAddress = exports.getAddress = exports.getCreate2Address = exports.getCreateAddress = exports.getContractAddress = exports.publicKeyToAddress = exports.parseAccount = exports.formatAbiParams = exports.formatAbiItem = exports.formatAbiItemWithArgs = exports.encodePacked = exports.parseAbiParameters = exports.parseAbiParameter = exports.parseAbiItem = exports.parseAbi = exports.getAbiItem = exports.encodeFunctionResult = exports.encodeFunctionData = exports.encodeEventTopics = exports.encodeErrorResult = exports.encodeDeployData = exports.encodeAbiParameters = exports.decodeFunctionResult = exports.decodeFunctionData = exports.decodeEventLog = exports.decodeErrorResult = exports.decodeAbiParameters = exports.validateTypedData = exports.stringify = exports.rpc = exports.getSocket = exports.integerRegex = exports.bytesRegex = exports.arrayRegex = exports.getChainContractAddress = exports.extractChain = exports.defineChain = exports.assertCurrentChain = exports.offchainLookupSignature = exports.offchainLookupAbiItem = exports.offchainLookup = exports.ccipFetch = exports.buildRequest = exports.isDeterministicError = void 0;
  exports.getEstimateGasError = exports.getContractError = exports.getCallError = exports.getNodeError = exports.containsNodeError = exports.fromRlp = exports.hexToString = exports.hexToNumber = exports.hexToBigInt = exports.hexToBool = exports.fromHex = exports.fromBytes = exports.bytesToString = exports.bytesToNumber = exports.bytesToBool = exports.bytesToBigint = exports.bytesToBigInt = exports.stringToHex = exports.numberToHex = exports.toHex = exports.bytesToHex = exports.boolToHex = exports.stringToBytes = exports.numberToBytes = exports.hexToBytes = exports.toBytes = exports.boolToBytes = exports.toRlp = exports.extract = exports.formatTransactionRequest = exports.defineTransactionRequest = exports.defineTransactionReceipt = exports.formatLog = exports.transactionType = exports.formatTransaction = exports.defineTransaction = exports.formatBlock = exports.defineBlock = exports.trim = exports.sliceHex = exports.sliceBytes = exports.slice = exports.size = exports.padHex = exports.padBytes = exports.pad = exports.isHex = exports.isBytes = exports.concatHex = exports.concatBytes = void 0;
  exports.parseGwei = exports.parseEther = exports.parseUnits = exports.formatUnits = exports.formatGwei = exports.formatEther = exports.serializeAccessList = exports.serializeTransaction = exports.prepareTransactionRequest = exports.parseTransaction = exports.assertTransactionLegacy = exports.assertTransactionEIP2930 = exports.assertTransactionEIP1559 = exports.assertRequest = exports.getTransactionType = exports.getSerializedTransactionType = exports.hashMessage = exports.verifyTypedData = exports.verifyMessage = exports.recoverTypedDataAddress = exports.recoverPublicKey = exports.recoverMessageAddress = exports.recoverAddress = exports.hashTypedData = exports.keccak256 = exports.isHash = exports.getFunctionSelector = exports.getEventSelector = exports.defineFormatter = exports.getTransactionError = void 0;
  var buildRequest_js_1 = _buildRequestDew();
  Object.defineProperty(exports, "isDeterministicError", {
    enumerable: true,
    get: function () {
      return buildRequest_js_1.isDeterministicError;
    }
  });
  Object.defineProperty(exports, "buildRequest", {
    enumerable: true,
    get: function () {
      return buildRequest_js_1.buildRequest;
    }
  });
  var ccip_js_1 = _ccipDew();
  Object.defineProperty(exports, "ccipFetch", {
    enumerable: true,
    get: function () {
      return ccip_js_1.ccipFetch;
    }
  });
  Object.defineProperty(exports, "offchainLookup", {
    enumerable: true,
    get: function () {
      return ccip_js_1.offchainLookup;
    }
  });
  Object.defineProperty(exports, "offchainLookupAbiItem", {
    enumerable: true,
    get: function () {
      return ccip_js_1.offchainLookupAbiItem;
    }
  });
  Object.defineProperty(exports, "offchainLookupSignature", {
    enumerable: true,
    get: function () {
      return ccip_js_1.offchainLookupSignature;
    }
  });
  var assertCurrentChain_js_1 = _assertCurrentChainDew();
  Object.defineProperty(exports, "assertCurrentChain", {
    enumerable: true,
    get: function () {
      return assertCurrentChain_js_1.assertCurrentChain;
    }
  });
  var defineChain_js_1 = _defineChainDew();
  Object.defineProperty(exports, "defineChain", {
    enumerable: true,
    get: function () {
      return defineChain_js_1.defineChain;
    }
  });
  var extractChain_js_1 = _extractChainDew();
  Object.defineProperty(exports, "extractChain", {
    enumerable: true,
    get: function () {
      return extractChain_js_1.extractChain;
    }
  });
  var getChainContractAddress_js_1 = _getChainContractAddressDew();
  Object.defineProperty(exports, "getChainContractAddress", {
    enumerable: true,
    get: function () {
      return getChainContractAddress_js_1.getChainContractAddress;
    }
  });
  var regex_js_1 = _regexDew();
  Object.defineProperty(exports, "arrayRegex", {
    enumerable: true,
    get: function () {
      return regex_js_1.arrayRegex;
    }
  });
  Object.defineProperty(exports, "bytesRegex", {
    enumerable: true,
    get: function () {
      return regex_js_1.bytesRegex;
    }
  });
  Object.defineProperty(exports, "integerRegex", {
    enumerable: true,
    get: function () {
      return regex_js_1.integerRegex;
    }
  });
  var rpc_js_1 = _rpcDew();
  Object.defineProperty(exports, "getSocket", {
    enumerable: true,
    get: function () {
      return rpc_js_1.getSocket;
    }
  });
  Object.defineProperty(exports, "rpc", {
    enumerable: true,
    get: function () {
      return rpc_js_1.rpc;
    }
  });
  var stringify_js_1 = _stringifyDew();
  Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function () {
      return stringify_js_1.stringify;
    }
  });
  var typedData_js_1 = _typedDataDew();
  Object.defineProperty(exports, "validateTypedData", {
    enumerable: true,
    get: function () {
      return typedData_js_1.validateTypedData;
    }
  });
  var decodeAbiParameters_js_1 = _decodeAbiParametersDew();
  Object.defineProperty(exports, "decodeAbiParameters", {
    enumerable: true,
    get: function () {
      return decodeAbiParameters_js_1.decodeAbiParameters;
    }
  });
  var decodeErrorResult_js_1 = _decodeErrorResultDew();
  Object.defineProperty(exports, "decodeErrorResult", {
    enumerable: true,
    get: function () {
      return decodeErrorResult_js_1.decodeErrorResult;
    }
  });
  var decodeEventLog_js_1 = _decodeEventLogDew();
  Object.defineProperty(exports, "decodeEventLog", {
    enumerable: true,
    get: function () {
      return decodeEventLog_js_1.decodeEventLog;
    }
  });
  var decodeFunctionData_js_1 = _decodeFunctionDataDew();
  Object.defineProperty(exports, "decodeFunctionData", {
    enumerable: true,
    get: function () {
      return decodeFunctionData_js_1.decodeFunctionData;
    }
  });
  var decodeFunctionResult_js_1 = _decodeFunctionResultDew();
  Object.defineProperty(exports, "decodeFunctionResult", {
    enumerable: true,
    get: function () {
      return decodeFunctionResult_js_1.decodeFunctionResult;
    }
  });
  var encodeAbiParameters_js_1 = _encodeAbiParametersDew();
  Object.defineProperty(exports, "encodeAbiParameters", {
    enumerable: true,
    get: function () {
      return encodeAbiParameters_js_1.encodeAbiParameters;
    }
  });
  var encodeDeployData_js_1 = _encodeDeployDataDew();
  Object.defineProperty(exports, "encodeDeployData", {
    enumerable: true,
    get: function () {
      return encodeDeployData_js_1.encodeDeployData;
    }
  });
  var encodeErrorResult_js_1 = _encodeErrorResultDew();
  Object.defineProperty(exports, "encodeErrorResult", {
    enumerable: true,
    get: function () {
      return encodeErrorResult_js_1.encodeErrorResult;
    }
  });
  var encodeEventTopics_js_1 = _encodeEventTopicsDew();
  Object.defineProperty(exports, "encodeEventTopics", {
    enumerable: true,
    get: function () {
      return encodeEventTopics_js_1.encodeEventTopics;
    }
  });
  var encodeFunctionData_js_1 = _encodeFunctionDataDew();
  Object.defineProperty(exports, "encodeFunctionData", {
    enumerable: true,
    get: function () {
      return encodeFunctionData_js_1.encodeFunctionData;
    }
  });
  var encodeFunctionResult_js_1 = _encodeFunctionResultDew();
  Object.defineProperty(exports, "encodeFunctionResult", {
    enumerable: true,
    get: function () {
      return encodeFunctionResult_js_1.encodeFunctionResult;
    }
  });
  var getAbiItem_js_1 = _getAbiItemDew();
  Object.defineProperty(exports, "getAbiItem", {
    enumerable: true,
    get: function () {
      return getAbiItem_js_1.getAbiItem;
    }
  });
  var abitype_1 = _abitype;
  Object.defineProperty(exports, "parseAbi", {
    enumerable: true,
    get: function () {
      return abitype_1.parseAbi;
    }
  });
  Object.defineProperty(exports, "parseAbiItem", {
    enumerable: true,
    get: function () {
      return abitype_1.parseAbiItem;
    }
  });
  Object.defineProperty(exports, "parseAbiParameter", {
    enumerable: true,
    get: function () {
      return abitype_1.parseAbiParameter;
    }
  });
  Object.defineProperty(exports, "parseAbiParameters", {
    enumerable: true,
    get: function () {
      return abitype_1.parseAbiParameters;
    }
  });
  var encodePacked_js_1 = _encodePackedDew();
  Object.defineProperty(exports, "encodePacked", {
    enumerable: true,
    get: function () {
      return encodePacked_js_1.encodePacked;
    }
  });
  var formatAbiItemWithArgs_js_1 = _formatAbiItemWithArgsDew();
  Object.defineProperty(exports, "formatAbiItemWithArgs", {
    enumerable: true,
    get: function () {
      return formatAbiItemWithArgs_js_1.formatAbiItemWithArgs;
    }
  });
  var formatAbiItem_js_1 = _formatAbiItemDew();
  Object.defineProperty(exports, "formatAbiItem", {
    enumerable: true,
    get: function () {
      return formatAbiItem_js_1.formatAbiItem;
    }
  });
  Object.defineProperty(exports, "formatAbiParams", {
    enumerable: true,
    get: function () {
      return formatAbiItem_js_1.formatAbiParams;
    }
  });
  var parseAccount_js_1 = _parseAccountDew();
  Object.defineProperty(exports, "parseAccount", {
    enumerable: true,
    get: function () {
      return parseAccount_js_1.parseAccount;
    }
  });
  var publicKeyToAddress_js_1 = _publicKeyToAddressDew();
  Object.defineProperty(exports, "publicKeyToAddress", {
    enumerable: true,
    get: function () {
      return publicKeyToAddress_js_1.publicKeyToAddress;
    }
  });
  var getContractAddress_js_1 = _getContractAddressDew();
  Object.defineProperty(exports, "getContractAddress", {
    enumerable: true,
    get: function () {
      return getContractAddress_js_1.getContractAddress;
    }
  });
  Object.defineProperty(exports, "getCreateAddress", {
    enumerable: true,
    get: function () {
      return getContractAddress_js_1.getCreateAddress;
    }
  });
  Object.defineProperty(exports, "getCreate2Address", {
    enumerable: true,
    get: function () {
      return getContractAddress_js_1.getCreate2Address;
    }
  });
  var getAddress_js_1 = _getAddressDew();
  Object.defineProperty(exports, "getAddress", {
    enumerable: true,
    get: function () {
      return getAddress_js_1.getAddress;
    }
  });
  var isAddress_js_1 = _isAddressDew();
  Object.defineProperty(exports, "isAddress", {
    enumerable: true,
    get: function () {
      return isAddress_js_1.isAddress;
    }
  });
  var isAddressEqual_js_1 = _isAddressEqualDew();
  Object.defineProperty(exports, "isAddressEqual", {
    enumerable: true,
    get: function () {
      return isAddressEqual_js_1.isAddressEqual;
    }
  });
  var extractFunctionParts_js_1 = _extractFunctionPartsDew();
  Object.defineProperty(exports, "extractFunctionName", {
    enumerable: true,
    get: function () {
      return extractFunctionParts_js_1.extractFunctionName;
    }
  });
  Object.defineProperty(exports, "extractFunctionParams", {
    enumerable: true,
    get: function () {
      return extractFunctionParts_js_1.extractFunctionParams;
    }
  });
  Object.defineProperty(exports, "extractFunctionType", {
    enumerable: true,
    get: function () {
      return extractFunctionParts_js_1.extractFunctionType;
    }
  });
  Object.defineProperty(exports, "extractFunctionParts", {
    enumerable: true,
    get: function () {
      return extractFunctionParts_js_1.extractFunctionParts;
    }
  });
  var concat_js_1 = _concatDew();
  Object.defineProperty(exports, "concat", {
    enumerable: true,
    get: function () {
      return concat_js_1.concat;
    }
  });
  Object.defineProperty(exports, "concatBytes", {
    enumerable: true,
    get: function () {
      return concat_js_1.concatBytes;
    }
  });
  Object.defineProperty(exports, "concatHex", {
    enumerable: true,
    get: function () {
      return concat_js_1.concatHex;
    }
  });
  var isBytes_js_1 = _isBytesDew();
  Object.defineProperty(exports, "isBytes", {
    enumerable: true,
    get: function () {
      return isBytes_js_1.isBytes;
    }
  });
  var isHex_js_1 = _isHexDew();
  Object.defineProperty(exports, "isHex", {
    enumerable: true,
    get: function () {
      return isHex_js_1.isHex;
    }
  });
  var pad_js_1 = _padDew();
  Object.defineProperty(exports, "pad", {
    enumerable: true,
    get: function () {
      return pad_js_1.pad;
    }
  });
  Object.defineProperty(exports, "padBytes", {
    enumerable: true,
    get: function () {
      return pad_js_1.padBytes;
    }
  });
  Object.defineProperty(exports, "padHex", {
    enumerable: true,
    get: function () {
      return pad_js_1.padHex;
    }
  });
  var size_js_1 = _sizeDew();
  Object.defineProperty(exports, "size", {
    enumerable: true,
    get: function () {
      return size_js_1.size;
    }
  });
  var slice_js_1 = _sliceDew();
  Object.defineProperty(exports, "slice", {
    enumerable: true,
    get: function () {
      return slice_js_1.slice;
    }
  });
  Object.defineProperty(exports, "sliceBytes", {
    enumerable: true,
    get: function () {
      return slice_js_1.sliceBytes;
    }
  });
  Object.defineProperty(exports, "sliceHex", {
    enumerable: true,
    get: function () {
      return slice_js_1.sliceHex;
    }
  });
  var trim_js_1 = _trimDew();
  Object.defineProperty(exports, "trim", {
    enumerable: true,
    get: function () {
      return trim_js_1.trim;
    }
  });
  var block_js_1 = _blockDew();
  Object.defineProperty(exports, "defineBlock", {
    enumerable: true,
    get: function () {
      return block_js_1.defineBlock;
    }
  });
  Object.defineProperty(exports, "formatBlock", {
    enumerable: true,
    get: function () {
      return block_js_1.formatBlock;
    }
  });
  var transaction_js_1 = _transactionDew();
  Object.defineProperty(exports, "defineTransaction", {
    enumerable: true,
    get: function () {
      return transaction_js_1.defineTransaction;
    }
  });
  Object.defineProperty(exports, "formatTransaction", {
    enumerable: true,
    get: function () {
      return transaction_js_1.formatTransaction;
    }
  });
  Object.defineProperty(exports, "transactionType", {
    enumerable: true,
    get: function () {
      return transaction_js_1.transactionType;
    }
  });
  var log_js_1 = _logDew();
  Object.defineProperty(exports, "formatLog", {
    enumerable: true,
    get: function () {
      return log_js_1.formatLog;
    }
  });
  var transactionReceipt_js_1 = _transactionReceiptDew();
  Object.defineProperty(exports, "defineTransactionReceipt", {
    enumerable: true,
    get: function () {
      return transactionReceipt_js_1.defineTransactionReceipt;
    }
  });
  var transactionRequest_js_1 = _transactionRequestDew();
  Object.defineProperty(exports, "defineTransactionRequest", {
    enumerable: true,
    get: function () {
      return transactionRequest_js_1.defineTransactionRequest;
    }
  });
  Object.defineProperty(exports, "formatTransactionRequest", {
    enumerable: true,
    get: function () {
      return transactionRequest_js_1.formatTransactionRequest;
    }
  });
  var extract_js_1 = _extractDew();
  Object.defineProperty(exports, "extract", {
    enumerable: true,
    get: function () {
      return extract_js_1.extract;
    }
  });
  var toRlp_js_1 = _toRlpDew();
  Object.defineProperty(exports, "toRlp", {
    enumerable: true,
    get: function () {
      return toRlp_js_1.toRlp;
    }
  });
  var toBytes_js_1 = _toBytesDew();
  Object.defineProperty(exports, "boolToBytes", {
    enumerable: true,
    get: function () {
      return toBytes_js_1.boolToBytes;
    }
  });
  Object.defineProperty(exports, "toBytes", {
    enumerable: true,
    get: function () {
      return toBytes_js_1.toBytes;
    }
  });
  Object.defineProperty(exports, "hexToBytes", {
    enumerable: true,
    get: function () {
      return toBytes_js_1.hexToBytes;
    }
  });
  Object.defineProperty(exports, "numberToBytes", {
    enumerable: true,
    get: function () {
      return toBytes_js_1.numberToBytes;
    }
  });
  Object.defineProperty(exports, "stringToBytes", {
    enumerable: true,
    get: function () {
      return toBytes_js_1.stringToBytes;
    }
  });
  var toHex_js_1 = _toHexDew();
  Object.defineProperty(exports, "boolToHex", {
    enumerable: true,
    get: function () {
      return toHex_js_1.boolToHex;
    }
  });
  Object.defineProperty(exports, "bytesToHex", {
    enumerable: true,
    get: function () {
      return toHex_js_1.bytesToHex;
    }
  });
  Object.defineProperty(exports, "toHex", {
    enumerable: true,
    get: function () {
      return toHex_js_1.toHex;
    }
  });
  Object.defineProperty(exports, "numberToHex", {
    enumerable: true,
    get: function () {
      return toHex_js_1.numberToHex;
    }
  });
  Object.defineProperty(exports, "stringToHex", {
    enumerable: true,
    get: function () {
      return toHex_js_1.stringToHex;
    }
  });
  var fromBytes_js_1 = _fromBytesDew();
  Object.defineProperty(exports, "bytesToBigInt", {
    enumerable: true,
    get: function () {
      return fromBytes_js_1.bytesToBigInt;
    }
  });
  Object.defineProperty(exports, "bytesToBigint", {
    enumerable: true,
    get: function () {
      return fromBytes_js_1.bytesToBigInt;
    }
  });
  Object.defineProperty(exports, "bytesToBool", {
    enumerable: true,
    get: function () {
      return fromBytes_js_1.bytesToBool;
    }
  });
  Object.defineProperty(exports, "bytesToNumber", {
    enumerable: true,
    get: function () {
      return fromBytes_js_1.bytesToNumber;
    }
  });
  Object.defineProperty(exports, "bytesToString", {
    enumerable: true,
    get: function () {
      return fromBytes_js_1.bytesToString;
    }
  });
  Object.defineProperty(exports, "fromBytes", {
    enumerable: true,
    get: function () {
      return fromBytes_js_1.fromBytes;
    }
  });
  var fromHex_js_1 = _fromHexDew();
  Object.defineProperty(exports, "fromHex", {
    enumerable: true,
    get: function () {
      return fromHex_js_1.fromHex;
    }
  });
  Object.defineProperty(exports, "hexToBool", {
    enumerable: true,
    get: function () {
      return fromHex_js_1.hexToBool;
    }
  });
  Object.defineProperty(exports, "hexToBigInt", {
    enumerable: true,
    get: function () {
      return fromHex_js_1.hexToBigInt;
    }
  });
  Object.defineProperty(exports, "hexToNumber", {
    enumerable: true,
    get: function () {
      return fromHex_js_1.hexToNumber;
    }
  });
  Object.defineProperty(exports, "hexToString", {
    enumerable: true,
    get: function () {
      return fromHex_js_1.hexToString;
    }
  });
  var fromRlp_js_1 = _fromRlpDew();
  Object.defineProperty(exports, "fromRlp", {
    enumerable: true,
    get: function () {
      return fromRlp_js_1.fromRlp;
    }
  });
  var getNodeError_js_1 = _getNodeErrorDew();
  Object.defineProperty(exports, "containsNodeError", {
    enumerable: true,
    get: function () {
      return getNodeError_js_1.containsNodeError;
    }
  });
  Object.defineProperty(exports, "getNodeError", {
    enumerable: true,
    get: function () {
      return getNodeError_js_1.getNodeError;
    }
  });
  var getCallError_js_1 = _getCallErrorDew();
  Object.defineProperty(exports, "getCallError", {
    enumerable: true,
    get: function () {
      return getCallError_js_1.getCallError;
    }
  });
  var getContractError_js_1 = _getContractErrorDew();
  Object.defineProperty(exports, "getContractError", {
    enumerable: true,
    get: function () {
      return getContractError_js_1.getContractError;
    }
  });
  var getEstimateGasError_js_1 = _getEstimateGasErrorDew();
  Object.defineProperty(exports, "getEstimateGasError", {
    enumerable: true,
    get: function () {
      return getEstimateGasError_js_1.getEstimateGasError;
    }
  });
  var getTransactionError_js_1 = _getTransactionErrorDew();
  Object.defineProperty(exports, "getTransactionError", {
    enumerable: true,
    get: function () {
      return getTransactionError_js_1.getTransactionError;
    }
  });
  var formatter_js_1 = _formatterDew();
  Object.defineProperty(exports, "defineFormatter", {
    enumerable: true,
    get: function () {
      return formatter_js_1.defineFormatter;
    }
  });
  var getEventSelector_js_1 = _getEventSelectorDew();
  Object.defineProperty(exports, "getEventSelector", {
    enumerable: true,
    get: function () {
      return getEventSelector_js_1.getEventSelector;
    }
  });
  var getFunctionSelector_js_1 = _getFunctionSelectorDew();
  Object.defineProperty(exports, "getFunctionSelector", {
    enumerable: true,
    get: function () {
      return getFunctionSelector_js_1.getFunctionSelector;
    }
  });
  var isHash_js_1 = _isHashDew();
  Object.defineProperty(exports, "isHash", {
    enumerable: true,
    get: function () {
      return isHash_js_1.isHash;
    }
  });
  var keccak256_js_1 = _keccakDew();
  Object.defineProperty(exports, "keccak256", {
    enumerable: true,
    get: function () {
      return keccak256_js_1.keccak256;
    }
  });
  var hashTypedData_js_1 = _hashTypedDataDew();
  Object.defineProperty(exports, "hashTypedData", {
    enumerable: true,
    get: function () {
      return hashTypedData_js_1.hashTypedData;
    }
  });
  var recoverAddress_js_1 = _recoverAddressDew();
  Object.defineProperty(exports, "recoverAddress", {
    enumerable: true,
    get: function () {
      return recoverAddress_js_1.recoverAddress;
    }
  });
  var recoverMessageAddress_js_1 = _recoverMessageAddressDew();
  Object.defineProperty(exports, "recoverMessageAddress", {
    enumerable: true,
    get: function () {
      return recoverMessageAddress_js_1.recoverMessageAddress;
    }
  });
  var recoverPublicKey_js_1 = _recoverPublicKeyDew();
  Object.defineProperty(exports, "recoverPublicKey", {
    enumerable: true,
    get: function () {
      return recoverPublicKey_js_1.recoverPublicKey;
    }
  });
  var recoverTypedDataAddress_js_1 = _recoverTypedDataAddressDew();
  Object.defineProperty(exports, "recoverTypedDataAddress", {
    enumerable: true,
    get: function () {
      return recoverTypedDataAddress_js_1.recoverTypedDataAddress;
    }
  });
  var verifyMessage_js_1 = _verifyMessageDew();
  Object.defineProperty(exports, "verifyMessage", {
    enumerable: true,
    get: function () {
      return verifyMessage_js_1.verifyMessage;
    }
  });
  var verifyTypedData_js_1 = _verifyTypedDataDew();
  Object.defineProperty(exports, "verifyTypedData", {
    enumerable: true,
    get: function () {
      return verifyTypedData_js_1.verifyTypedData;
    }
  });
  var hashMessage_js_1 = _hashMessageDew();
  Object.defineProperty(exports, "hashMessage", {
    enumerable: true,
    get: function () {
      return hashMessage_js_1.hashMessage;
    }
  });
  var getSerializedTransactionType_js_1 = _getSerializedTransactionTypeDew();
  Object.defineProperty(exports, "getSerializedTransactionType", {
    enumerable: true,
    get: function () {
      return getSerializedTransactionType_js_1.getSerializedTransactionType;
    }
  });
  var getTransactionType_js_1 = _getTransactionTypeDew();
  Object.defineProperty(exports, "getTransactionType", {
    enumerable: true,
    get: function () {
      return getTransactionType_js_1.getTransactionType;
    }
  });
  var assertRequest_js_1 = _assertRequestDew();
  Object.defineProperty(exports, "assertRequest", {
    enumerable: true,
    get: function () {
      return assertRequest_js_1.assertRequest;
    }
  });
  var assertTransaction_js_1 = _assertTransactionDew();
  Object.defineProperty(exports, "assertTransactionEIP1559", {
    enumerable: true,
    get: function () {
      return assertTransaction_js_1.assertTransactionEIP1559;
    }
  });
  Object.defineProperty(exports, "assertTransactionEIP2930", {
    enumerable: true,
    get: function () {
      return assertTransaction_js_1.assertTransactionEIP2930;
    }
  });
  Object.defineProperty(exports, "assertTransactionLegacy", {
    enumerable: true,
    get: function () {
      return assertTransaction_js_1.assertTransactionLegacy;
    }
  });
  var parseTransaction_js_1 = _parseTransactionDew();
  Object.defineProperty(exports, "parseTransaction", {
    enumerable: true,
    get: function () {
      return parseTransaction_js_1.parseTransaction;
    }
  });
  var prepareTransactionRequest_js_1 = _prepareTransactionRequestDew();
  Object.defineProperty(exports, "prepareTransactionRequest", {
    enumerable: true,
    get: function () {
      return prepareTransactionRequest_js_1.prepareTransactionRequest;
    }
  });
  var serializeTransaction_js_1 = _serializeTransactionDew();
  Object.defineProperty(exports, "serializeTransaction", {
    enumerable: true,
    get: function () {
      return serializeTransaction_js_1.serializeTransaction;
    }
  });
  var serializeAccessList_js_1 = _serializeAccessListDew();
  Object.defineProperty(exports, "serializeAccessList", {
    enumerable: true,
    get: function () {
      return serializeAccessList_js_1.serializeAccessList;
    }
  });
  var formatEther_js_1 = _formatEtherDew();
  Object.defineProperty(exports, "formatEther", {
    enumerable: true,
    get: function () {
      return formatEther_js_1.formatEther;
    }
  });
  var formatGwei_js_1 = _formatGweiDew();
  Object.defineProperty(exports, "formatGwei", {
    enumerable: true,
    get: function () {
      return formatGwei_js_1.formatGwei;
    }
  });
  var formatUnits_js_1 = _formatUnitsDew();
  Object.defineProperty(exports, "formatUnits", {
    enumerable: true,
    get: function () {
      return formatUnits_js_1.formatUnits;
    }
  });
  var parseUnits_js_1 = _parseUnitsDew();
  Object.defineProperty(exports, "parseUnits", {
    enumerable: true,
    get: function () {
      return parseUnits_js_1.parseUnits;
    }
  });
  var parseEther_js_1 = _parseEtherDew();
  Object.defineProperty(exports, "parseEther", {
    enumerable: true,
    get: function () {
      return parseEther_js_1.parseEther;
    }
  });
  var parseGwei_js_1 = _parseGweiDew();
  Object.defineProperty(exports, "parseGwei", {
    enumerable: true,
    get: function () {
      return parseGwei_js_1.parseGwei;
    }
  });
  //# sourceMappingURL=index.js.map
  return exports;
}